export interface BnpPreview {
  readonly digest: string;
  readonly kind: 'XLS' | 'PDF' | 'ZIP';
  readonly accountLabel: string | null;
  readonly rowCount: number;
  readonly firstDate: string | null;
  readonly lastDate: string | null;
  readonly balanceDate: string | null;
  readonly requiresAccountConfirmation: boolean;
  readonly files?: readonly { name: string; kind: 'XLS' | 'PDF'; rowCount: number }[];
}
export interface BnpImportHistory {
  readonly id: string;
  readonly sourceImportId: string;
  readonly imported: boolean;
  readonly kind: 'XLS' | 'PDF';
  readonly rowCount: number;
  readonly firstDate: string | null;
  readonly lastDate: string | null;
  readonly balanceDate: string | null;
  readonly importedAt: string;
}

export const bnpConnectionApi = {
  async history(): Promise<readonly BnpImportHistory[]> {
    const response = await fetch('/api/integrations/bnp/history', { credentials: 'include' });
    if (!response.ok) throw new Error('Historique BNP indisponible.');
    return response.json() as Promise<readonly BnpImportHistory[]>;
  },
  async preview(file: File, kind: 'XLS' | 'PDF' | 'ZIP', csrfToken: string): Promise<BnpPreview> {
    const response = await fetch(`/api/integrations/bnp/preview/${kind.toLowerCase()}`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type':
          kind === 'XLS'
            ? 'application/vnd.ms-excel'
            : kind === 'PDF'
              ? 'application/pdf'
              : 'application/zip',
        'X-CSRF-Token': csrfToken,
      },
      body: await file.arrayBuffer(),
    });
    if (!response.ok) throw new Error('Fichier BNP non reconnu ou autre compte.');
    return response.json() as Promise<BnpPreview>;
  },
  async import(file: File, preview: BnpPreview, csrfToken: string, confirmed: boolean) {
    const response = await fetch(`/api/integrations/bnp/import/${preview.kind.toLowerCase()}`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type':
          preview.kind === 'XLS'
            ? 'application/vnd.ms-excel'
            : preview.kind === 'PDF'
              ? 'application/pdf'
              : 'application/zip',
        'X-CSRF-Token': csrfToken,
        'x-tosho-file-sha256': preview.digest,
        'x-tosho-sole-account-confirmed': String(confirmed),
      },
      body: await file.arrayBuffer(),
    });
    if (!response.ok) throw new Error('Import BNP refusé.');
    return response.json() as Promise<{
      imported: boolean;
      rowCount: number;
      filesImported?: number;
      filesAlreadyPresent?: number;
    }>;
  },
};
